var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f44335",
    d: "M59 10v7H1v-7a4 4 0 0 1 4-4h50a4 4 0 0 1 4 4z",
    opacity: 1,
    "data-original": "#f44335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c81e1e",
    d: "M55 6h-3a4 4 0 0 1 4 4v7h3v-7a4 4 0 0 0-4-4z",
    opacity: 1,
    "data-original": "#c81e1e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M59 17v38a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V17z",
    opacity: 1,
    "data-original": "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M56 17v38a4 4 0 0 1-4 4h3a4 4 0 0 0 4-4V17z",
    opacity: 1,
    "data-original": "#cfd8dc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 6,
    y: 1,
    fill: "#7f8e94",
    rx: 3,
    opacity: 1,
    "data-original": "#7f8e94"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 20,
    y: 1,
    fill: "#7f8e94",
    rx: 3,
    opacity: 1,
    "data-original": "#7f8e94"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 34,
    y: 1,
    fill: "#7f8e94",
    rx: 3,
    opacity: 1,
    "data-original": "#7f8e94"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 48,
    y: 1,
    fill: "#7f8e94",
    rx: 3,
    opacity: 1,
    "data-original": "#7f8e94"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 7,
    y: 21,
    fill: "#02a9f4",
    rx: 1,
    opacity: 1,
    "data-original": "#02a9f4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 7,
    y: 33,
    fill: "#02a9f4",
    rx: 1,
    opacity: 1,
    "data-original": "#02a9f4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 7,
    y: 45,
    fill: "#02a9f4",
    rx: 1,
    opacity: 1,
    "data-original": "#02a9f4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M55 5V4a4 4 0 1 0-8 0v1h-6V4a4 4 0 1 0-8 0v1h-6V4a4 4 0 1 0-8 0v1h-6V4a4 4 0 1 0-8 0v1a5.006 5.006 0 0 0-5 5v45a5.006 5.006 0 0 0 5 5h50a5.006 5.006 0 0 0 5-5V10a5.006 5.006 0 0 0-5-5zm-6-1a2 2 0 1 1 4 0v6a2 2 0 1 1-4 0zM35 4a2 2 0 1 1 4 0v6a2 2 0 1 1-4 0zM21 4a2 2 0 1 1 4 0v6a2 2 0 1 1-4 0zM7 4a2 2 0 1 1 4 0v6a2 2 0 1 1-4 0zM5 7v3a4 4 0 1 0 8 0V7h6v3a4 4 0 1 0 8 0V7h6v3a4 4 0 1 0 8 0V7h6v3a4 4 0 1 0 8 0V7a3 3 0 0 1 3 3v6H2v-6a3 3 0 0 1 3-3zm50 51H5a3 3 0 0 1-3-3V18h56v37a3 3 0 0 1-3 3z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M14 20H8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-6 8v-6h6v6z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 24h17a1 1 0 0 0 0-2H21a1 1 0 0 0 0 2zM53 22H42a1 1 0 0 0 0 2h11a1 1 0 0 0 0-2zM21 28h24a1 1 0 0 0 0-2H21a1 1 0 0 0 0 2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M14 32H8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-6 8v-6h6v6z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 36h17a1 1 0 0 0 0-2H21a1 1 0 0 0 0 2zM53 34H42a1 1 0 0 0 0 2h11a1 1 0 0 0 0-2zM21 40h24a1 1 0 0 0 0-2H21a1 1 0 0 0 0 2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M14 44H8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-6 8v-6h6v6z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 48h17a1 1 0 0 0 0-2H21a1 1 0 0 0 0 2zM53 46H42a1 1 0 0 0 0 2h11a1 1 0 0 0 0-2zM45 50H21a1 1 0 0 0 0 2h24a1 1 0 0 0 0-2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.5f1507d916d6e63bfd83698fa1ae19d4.svg";
export { ForwardRef as ReactComponent };